<template>
  <div class="col l4 m6 s12">
    <router-link :to="'/nihom-content/'+data.id">
      <div class="card card-content">
        <h6>{{ data.name }}</h6>
      </div>
    </router-link>
  </div>
</template>
<script>
export default {
  props: ["data"]
};
</script>
<style lang="scss" scoped>
@import "@/style/colors.scss";
.card {
  padding: 10px;
  border-left: 10px solid $primaryColor;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
  color: $primaryColor;
}

.card:hover {
  transition: 5s;
  transform: scale(1.2);
}
</style>